import { unidades_medida } from "../global/data"

type Unidades = "longitud" | "peso" | "volumen" | "temperatura" | "velocidad"
export const obtenerUnidadesMedidaPorTipoPais = (tipo: Unidades, pais_code) => {
  if(!unidades_medida[tipo]) return false
  console.log(unidades_medida[tipo].units)
//  return unidades_medida[tipo].units.filter(u => u.countries.filter(co => [pais_code,"ALL","INT"].includes(co)).length)
  return unidades_medida[tipo].units
}